import { mapGetters, mapActions } from 'vuex'

export const documentsChartStoreActions = {
  ...mapActions('documentsChartStore', [
    'getDocumentStatistics',
    'getYearsDocStatistics'
  ])
}

export const documentsChartStoreData = {
  ...mapGetters('documentsChartStore', [
    'statisticsData',
    'statisticsLoading',
    'statisticsError',
    'statisticsMessage',
    'statisticsColors',
    'statisticsTitles',
    'statisticsSizes',
    'statisticsYears',
    'statisticsLabelsMonthly'
  ])
}
